// TradingViewWidget.jsx (수정 버전)
import React, { useEffect, useRef, memo } from 'react';

function DetailTradingView({ symbol = "AAPL" }) {
  const container = useRef();

  useEffect(() => {
    // symbol이 변경될 때마다 완전히 새로운 위젯 생성
    if (!container.current) return;

    // 기존 위젯 완전히 제거
    container.current.innerHTML = '<div class="tradingview-widget-container__widget" style="height: calc(100% - 32px); width: 100%;"></div>';

    console.log('Loading TradingView for symbol:', symbol);

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
      {
        "autosize": true,
        "symbol": "${symbol}",
        "interval": "D",
        "theme": "light",
        "style": "1",
        "locale": "kr",
        "timezone": "Asia/Seoul",
        "allow_symbol_change": false,
        "calendar": false,
        "withdateranges": false,
        "save_image": true,
        "details": true,
        "hotlist": false,
        "support_host": "https://www.tradingview.com"
      }`;
    
    container.current.appendChild(script);

    // cleanup 함수로 컴포넌트 언마운트 시 스크립트 제거
    return () => {
      if (container.current) {
        console.log('Cleaning up TradingView widget');
        container.current.innerHTML = '<div class="tradingview-widget-container__widget" style="height: calc(100% - 32px); width: 100%;"></div>';
      }
    };
  }, [symbol]); // symbol이 변경될 때마다 재실행
  
  return (
    <div className="tradingview-widget-container" ref={container} style={{ height: "100%", width: "100%" }}>
      <div className="tradingview-widget-container__widget" style={{ height: "calc(100% - 32px)", width: "100%" }}></div>
    </div>
  );
}

export default DetailTradingView;